/* DON'T EDIT THIS FILE: edit original and run build again */ import { UserProfile } from "../../framework/auth-profile/schema.ts";
import { canAccessTenant } from "../../framework/auth/allowed-tenants.ts";
import { getTenantCodeFromUrl } from "../../framework/url-parsing/parse-tenant-from-url.ts";
import { TenantIndex } from "../../framework/tenant-collection/tenant-index-entry.ts";

export const guessCurrentTenant = (
  tenantIndex: TenantIndex,
  realmFromUrl: string,
  profile: UserProfile | undefined
): string => {
  const tenantFromUrl = getTenantCodeFromUrl(tenantIndex, document.location);
  if (canAccessTenant(profile, tenantFromUrl)) {
    return tenantFromUrl;
  }
  // eslint-disable-next-line no-restricted-properties
  return profile?.tenant ?? realmFromUrl;
};
